import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {EmployeesUploadState} from '@local/redux/state/pages/employeesUpload';

// 初期ステートをこういう感じにするとページ増えたときのredux層の情報量が増えるけど
// 数百万件とか裁こうとしてる中でこういうのが多少あってもそもそも変わらんし
// ページ遷移時の遅延がない（最初から初期状態は持ってる）ほうがいいし
// stateなし、初期ロード前、ロード後の3段階管理する複雑さによる開発への影響と
// その結果の品質への影響のほうが大きいので、こうする。
const initialState: EmployeesUploadState = {
  mainTab: 'import',
  jobs: [],
  uploadState: 'ready',
};
const employeesUploadSlice = createSlice({
  name: 'employeesUpload',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Partial<EmployeesUploadState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clear: () => initialState,
  },
});
export const employeesUploadReducer = employeesUploadSlice.reducer;
export const employeesUploadActions = employeesUploadSlice.actions;
